import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { BookOpen, ChevronRight, Award, Trophy } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "./ui/card";
import { Progress } from "./ui/progress";
import { Badge } from "./ui/badge";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("mgbApprenantToken")}` });

export const MesFormations = () => {
  const [items, setItems] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/apprenant/formations`, { headers: authHeaders() });
      setItems(res.data);
    } catch { setItems([]); }
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <Card data-testid="mes-formations-card">
      <CardHeader>
        <CardTitle className="text-[#003087] flex items-center gap-2">
          <BookOpen className="h-5 w-5" /> Mes formations
        </CardTitle>
        <CardDescription>Suivez votre progression module par module, validez les quiz et obtenez votre certificat.</CardDescription>
      </CardHeader>
      <CardContent>
        {items === null ? (
          <p className="text-sm text-gray-500">Chargement…</p>
        ) : items.length === 0 ? (
          <p className="text-sm text-gray-500 italic" data-testid="mes-formations-empty">Aucune formation rattachée à votre compte pour le moment.</p>
        ) : (
          <div className="grid gap-3 md:grid-cols-2">
            {items.map((f) => (
              <Link
                key={f.code}
                to={`/apprenant/formation/${f.code}`}
                className="group block p-4 border border-gray-200 rounded-xl bg-white hover:border-[#F07B1D]/60 hover:shadow-md transition-all"
                data-testid={`formation-card-${f.code}`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <Badge className="bg-[#003087] text-white">{f.code}</Badge>
                      <Badge variant="outline" className={`text-[10px] ${f.type === "selfservice" ? "border-[#2196F3] text-[#2196F3]" : "border-[#F07B1D] text-[#F07B1D]"}`}>
                        {f.type === "selfservice" ? "Self-service" : "Présentiel / Mixte"}
                      </Badge>
                    </div>
                    <p className="font-heading font-bold text-[#003087] leading-snug">{f.title}</p>
                    <p className="text-xs text-gray-500 mt-1">
                      {f.nb_modules_done}/{f.nb_modules} modules · {f.hours} h
                    </p>
                  </div>
                  <ChevronRight className="h-5 w-5 text-gray-300 group-hover:text-[#F07B1D] shrink-0 transition-colors" />
                </div>
                <div className="mt-3 flex items-center gap-3">
                  <Progress value={f.pct} className="h-2 flex-1" />
                  <span className="text-sm font-bold text-[#003087] w-10 text-right" data-testid={`formation-pct-${f.code}`}>{f.pct}%</span>
                </div>
                <div className="mt-2 text-xs">
                  {f.certificat?.available ? (
                    <span className="inline-flex items-center gap-1 text-green-700 font-semibold"><Award className="h-3.5 w-3.5" /> Certificat disponible</span>
                  ) : f.final_quiz?.passed ? (
                    <span className="inline-flex items-center gap-1 text-green-700"><Trophy className="h-3.5 w-3.5" /> Quiz final validé</span>
                  ) : f.final_unlocked ? (
                    <span className="text-[#F07B1D] font-semibold">Quiz final débloqué</span>
                  ) : (
                    <span className="text-gray-500">Terminez les modules pour débloquer le quiz final</span>
                  )}
                </div>
              </Link>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
